import React, { useState } from 'react';

const Slider = () => {
  // Brand logos + info shown in the popup when clicked
  const brands = [
    { id: 1, logo: '/assest/logo/VOP.png', name: 'VOP', fullName: 'VOP', description: 'Opportunity Plan presentation for new prospects.' },
    { id: 2, logo: '/assest/logo/KYP.png', name: 'KYP', fullName: 'KYP', description: 'Detailed Product Training session by doctors.' },
    { id: 3, logo: '/assest/logo/EM.png', name: 'EM', fullName: 'Executive Meet', description: 'Corporate training program for all Ruby to Sapphire rank VBOs.' },
    { id: 4, logo: '/assest/logo/CL.png', name: 'CL', fullName: 'Champions League', description: 'Consistent and top performing leaders listed by rank.' },
    { id: 5, logo: '/assest/logo/CC.png', name: 'CC', fullName: 'Crown Circle', description: 'Leaders with a minimum quarterly income of ₹2,50,000.' },
    { id: 6, logo: '/assest/logo/ss.png', name: 'SS', fullName: 'Star Summit', description: '3 days Annual Corporate Residential Training program for all Star 1000 and above.' },
    { id: 7, logo: '/assest/logo/th.png', name: 'TH', fullName: 'Town Hall', description: 'Full day Annual corporate event for recognitions.' },
    { id: 8, logo: '/assest/logo/BOM.png', name: 'BOM', fullName: 'BOM', description: 'Business Owners Meet to discuss and plan business.' },
    { id: 9, logo: '/assest/logo/EDP.png', name: 'EDP', fullName: 'EDP', description: 'Entrepreneurial Development Program to enhance business building skills.' },
    { id: 10, logo: '/assest/logo/Foundation Diamond.png', name: 'Foundation Diamond', fullName: 'Foundation Diamond', description: 'Entrepreneurial Development Program to enhance business building skills.' },
    { id: 11, logo: '/assest/logo/Mission.png', name: 'Mission', fullName: 'Mission', description: 'Business Building Seminar.' },
    { id: 12, logo: '/assest/logo/t2t.png', name: 'T2T', fullName: 'Touch To Transform', description: 'Business Building Seminar.' },
    { id: 13, logo: '/assest/logo/VHL.png', name: 'VHL', fullName: 'Viva Health Live', description: 'Live call session with doctors for queries on product usage.' },
    { id: 14, logo: '/assest/logo/wings.png', name: 'Wings', fullName: 'Wings', description: 'Wings to Well ness is a doctors program with wellness and products as the key.' },
    { id: 15, logo: '/assest/logo/yoga.png', name: 'iRise', fullName: 'iRise', description: 'Morning Club Yoga sessions, open for public every morning Mon–Fri.' },
  ];

  const [selectedBrand, setSelectedBrand] = useState(null);

  const handleClose = () => setSelectedBrand(null);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) handleClose();
  };

  return (
    <div className="brand-section-wrapper">
      <section className="brand-section-2">
        <div className="brand-slider-wrapper">
          <div className="brand-slider-track">
            {/* Multiple sets of brands for seamless infinite scroll */}
            {[...brands, ...brands, ...brands].map((brand, idx) => (
              <div key={`${brand.id}-${idx}`} className="brand-slide">
                <div
                  className="brand-box-1"
                  onClick={() => setSelectedBrand(brand)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      setSelectedBrand(brand);
                    }
                  }}
                  aria-label={`Learn more about ${brand.fullName}`}
                >
                  <span className="brand-img-1">
                    <img src={brand.logo} alt={brand.name} />
                  </span>
                  <span className="brand-img-1">
                    <img src={brand.logo} alt={brand.name} />
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {selectedBrand && (
        <div
          className="brand-modal-overlay"
          onClick={handleOverlayClick}
          role="dialog"
          aria-modal="true"
          aria-labelledby="brand-modal-title"
        >
          <div className="brand-modal">
            <button
              className="brand-modal-close"
              onClick={handleClose}
              aria-label="Close"
            >
              &times;
            </button>
            <div className="brand-modal-logo">
              <img src={selectedBrand.logo} alt={selectedBrand.name} />
            </div>
            <h3 id="brand-modal-title" className="brand-modal-title">
              {selectedBrand.fullName}
            </h3>
            <p className="brand-modal-desc">{selectedBrand.description}</p>
          </div>
        </div>
      )}

      <style dangerouslySetInnerHTML={{ __html: `
        .brand-section-wrapper {
          width: 100%;
          overflow: hidden;
        }

        .brand-section-2 {
          background-color: #0f172a;
          margin: 0 30px;
          margin-top: 30px;
          padding: 60px 30px 30px;
          border-radius: 14px;
          position: relative;
        }

        .brand-slider-wrapper {
          width: 100%;
          overflow: hidden;
          position: relative;
        }

        .brand-slider-track {
          display: flex;
          gap: 30px;
          animation: scroll 30s linear infinite;
          will-change: transform;
          width: fit-content;
        }

        /* Pause animation on hover (optional) */
        .brand-slider-track:hover {
          animation-play-state: paused;
        }

        .brand-slide {
          flex-shrink: 0;
          width: 280px;
        }

        .brand-box-1 {
          position: relative;
          height: 180px;
          background: rgba(255, 255, 255, 0.05);
          border-radius: 16px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
          border: 1px solid rgba(255, 255, 255, 0.08);
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          overflow: hidden;
          transition: transform 0.3s ease;
          cursor: pointer;
        }

        .brand-box-1:focus-visible {
          outline: 2px solid #38bdf8;
          outline-offset: 2px;
        }

        .brand-img-1 {
          position: absolute;
          inset: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
          transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
          cursor: pointer;
        }

        .brand-img-1:first-child {
          opacity: 1;
          transform: translateY(0);
        }

        .brand-img-1:last-child {
          opacity: 0;
          transform: translateY(-20px);
        }

        .brand-box-1:hover .brand-img-1:first-child {
          opacity: 0;
          transform: translateY(20px);
        }

        .brand-box-1:hover .brand-img-1:last-child {
          opacity: 1;
          transform: translateY(0);
        }

        .brand-img-1 img {
          max-width: 95%;
          max-height: 95%;
          width: auto;
          height: auto;
          object-fit: contain;
          pointer-events: none;
        }

        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(calc(-280px * 15 - 30px * 15));
          }
        }

        /* Popup / modal */
        .brand-modal-overlay {
          position: fixed;
          inset: 0;
          background: rgba(2, 6, 23, 0.7);
          backdrop-filter: blur(4px);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          padding: 20px;
          animation: fadeIn 0.2s ease;
        }

        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        .brand-modal {
          position: relative;
          background: #0f172a;
          border: 1px solid rgba(255, 255, 255, 0.1);
          border-radius: 16px;
          padding: 36px 32px 32px;
          max-width: 420px;
          width: 100%;
          text-align: center;
          box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
          animation: popIn 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);
        }

        @keyframes popIn {
          from {
            opacity: 0;
            transform: scale(0.92) translateY(10px);
          }
          to {
            opacity: 1;
            transform: scale(1) translateY(0);
          }
        }

        .brand-modal-close {
          position: absolute;
          top: 12px;
          right: 14px;
          background: rgba(255, 255, 255, 0.08);
          border: none;
          color: #e2e8f0;
          width: 32px;
          height: 32px;
          border-radius: 50%;
          font-size: 20px;
          line-height: 1;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: background 0.2s ease;
        }

        .brand-modal-close:hover {
          background: rgba(255, 255, 255, 0.18);
        }

        .brand-modal-logo {
          width: 96px;
          height: 96px;
          margin: 0 auto 18px;
          background: rgba(255, 255, 255, 0.06);
          border-radius: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 12px;
        }

        .brand-modal-logo img {
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
        }

        .brand-modal-title {
          color: #f8fafc;
          font-size: 20px;
          font-weight: 600;
          margin: 0 0 10px;
        }

        .brand-modal-desc {
          color: #cbd5e1;
          font-size: 15px;
          line-height: 1.5;
          margin: 0;
        }

        /* Responsive adjustments */
        @media (max-width: 768px) {
          .brand-section-2 {
            margin: 0 15px;
            margin-top: 20px;
            padding: 40px 20px 20px;
            border-radius: 12px;
          }

          .brand-slide {
            width: 200px;
          }

          .brand-box-1 {
            height: 140px;
            padding: 18px;
          }

          .brand-slider-track {
            gap: 20px;
            animation-duration: 24s;
          }

          @keyframes scroll {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(calc(-200px * 15 - 20px * 15));
            }
          }

          .brand-modal {
            padding: 30px 22px 26px;
          }
        }

        @media (max-width: 480px) {
          .brand-section-2 {
            margin: 0 10px;
            margin-top: 15px;
            padding: 30px 15px 15px;
          }

          .brand-slide {
            width: 160px;
          }

          .brand-box-1 {
            height: 110px;
            padding: 15px;
          }

          .brand-slider-track {
            gap: 15px;
            animation-duration: 20s;
          }

          @keyframes scroll {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(calc(-160px * 15 - 15px * 15));
            }
          }
        }
      `}} />
    </div>
  );
};

export default Slider;